import { Injectable } from '@angular/core';
import { filter, shareReplay, switchMap } from 'rxjs/operators';
import { DashboardHttpService } from '../../core-services/dashboard-http-service/dashboard-http.service';
import { MerchantAd } from '../../core/dtos/api';
import { DashboardApiService } from '../../core/services/api/dashboard-api.service';
import { MerchantApiService } from '../../core/services/api/merchant-api.service';

@Injectable({
  providedIn: 'root'
})
export class AdManagementService {

  constructor(private merchantApiService: MerchantApiService, private dashboardApiService: DashboardApiService,
    private http: DashboardHttpService) { }

  readonly allMerchants = 'allMerchants';

  readonly promotionDetailsOptionsWithoutNone = ['BOGO', 'Discount', 'Free Shipping', 'Gift With Purchase', 'Rebate'].map(label => ({label, value: label}));

  readonly promotionDetailsOptions = [{label: 'None', value: ''}, ...this.promotionDetailsOptionsWithoutNone];

  merchantAds$ = this.dashboardApiService.currentAccount$.pipe(
    filter(x => x.entity_group_name === 'merchants'),
    switchMap(x => this.merchantApiService.getSinglePageOfMerchantAds(x.entity_id)),
    shareReplay({bufferSize: 1, refCount: true}));

  downloadAdImage(merchantAd: MerchantAd) {
    let imageUrl = new URL(merchantAd.image_url);
    // s3 has problems with caching and cors in chrome
    // see https://forums.aws.amazon.com/thread.jspa?threadID=342401
    imageUrl.searchParams.append('cors-cache-buster', Date.now().toString());

    return this.http.downloadBlobWithOptions(imageUrl.toString(), merchantAd.ad_original_image_name,
      { observe: 'response', responseType: 'blob', excludeDefaultHeaders: true });
  }

  getAdImage(url: string) {
    let imageUrl = new URL(url);
    // s3 has problems with caching and cors in chrome
    // see https://forums.aws.amazon.com/thread.jspa?threadID=342401
    imageUrl.searchParams.append('cors-cache-buster', Date.now().toString());

    return this.http.getBlobWithOptions(imageUrl.toString(), { observe: 'response', responseType: 'blob', excludeDefaultHeaders: true });
  }

  merchantWebsites$ = this.dashboardApiService.currentAccount$.pipe(
    filter(x => x.entity_group_name === 'merchants'),
    switchMap(currentAccount => this.merchantApiService.getMerchantWebsitesByEntityId(currentAccount.entity_id))
  );
}
